import { Route } from "@mapmycustomers/shared/types/entity";

import getRouteProgress from "./getRouteProgress";

type RouteStatus = "done" | "inProgress" | "notStarted";

const getRouteStatus = (route: Route): RouteStatus => {
  const progress = getRouteProgress(route);

  if (progress === 1) {
    return "done";
  }
  return progress > 0 ? "inProgress" : "notStarted";
};

export type { RouteStatus };
export default getRouteStatus;
